module.exports = "/_next/static/images/row3-2-2x-e458e71795d97bbd6fb68f4f42bc0462.png";